import React, { createContext, useMemo } from 'react'
import type { ReactNode } from 'react'

import type { TopDestinationsType } from 'src/types/topDestinations'

const TopDestinationsContext = createContext<TopDestinationsType | null>(null)

interface ITopDestinationsProviderProps {
  children: ReactNode
  value: TopDestinationsType
}

const TopDestinationsProvider = ({ children, value }: ITopDestinationsProviderProps) => {
  const { topDestinationsJSON } = value

  const topDestinationsValue = useMemo(
    () => ({
      topDestinationsJSON,
    }),
    [topDestinationsJSON]
  )

  return (
    <TopDestinationsContext.Provider value={topDestinationsValue}>
      {children}
    </TopDestinationsContext.Provider>
  )
}

export { TopDestinationsContext, TopDestinationsProvider }
